import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { useActiveOrganization } from '@/hooks/useActiveOrganization';
import { queryKeys } from '@/lib/query-keys';
import { executeQuery } from '@/lib/execute-query';
import { Action } from '@/business/types/action.types';
import type {
  GetMyProgressInput,
  GetMyProgressOutput,
} from '@/types/learning-progress.types';

const HEATMAP_WEEKS = 5;

export function useMyProgressQuery(
  targetUserId?: string,
  targetRole?: string,
  weeks = HEATMAP_WEEKS
) {
  const { user } = useAuth();
  const { activeOrganizationId } = useActiveOrganization();

  const effectiveUserId = targetUserId || user?.id;

  return useQuery({
    queryKey: queryKeys.myProgress.forUser(
      targetRole ? '__role__' : effectiveUserId!,
      activeOrganizationId,
      targetRole
    ),
    queryFn: () => {
      const body: GetMyProgressInput = {};
      if (targetRole) {
        body.target_role = targetRole;
      } else if (targetUserId) {
        body.target_user_id = targetUserId;
      }
      if (weeks) {
        body.weeks = weeks;
      }
      return executeQuery<GetMyProgressInput, GetMyProgressOutput>(
        Action.GET_MY_PROGRESS,
        body
      );
    },
    staleTime: 1000 * 60 * 5,
    enabled: !!targetRole || !!effectiveUserId,
  });
}
